var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invitees-list-item" },
    [
      _c("AvatarParticipationStatus", {
        attrs: {
          "attendee-is-organizer": true,
          "avatar-link": _vm.avatarLink,
          "is-viewed-by-organizer": _vm.isViewedByOrganizer,
          "common-name": _vm.commonName,
          "organizer-display-name": _vm.commonName,
          "participation-status": "ACCEPTED"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "invitees-list-item__displayname" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.commonName) + "\n\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "invitees-list-item__organizer-hint" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.$t("calendar", "(organizer)")) + "\n\t")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }